const TableTitleService = {
  title: 'Serviços',
  placeholder: 'Pesquisar',
  Typography: 'Nenhum resultado encontrado'
};

export default TableTitleService;
